import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { VulnerabilityPolicy } from '../.'

export const vulnerabilityPolicyQuery = gql`
  query VulnerabilityPolicy($organizationID: ID!, $policyID: ID!) {
    vulnerabilityPolicy(organizationID: $organizationID, policyID: $policyID) {
      id
      name
      enabled
      rules {
        title
        name
      }
      allRules
      applications {
        id
        name
      }
      allApplications
      serverEnvironments
      allServerEnvironments
      applicationImportance
      ruleSeverities
      remediationDays
      valid
      action
      timeBasedEnabled
      routeBasedEnabled
      autoVerificationType
    }
  }
`

export interface ChildProps {
  readonly vulnerabilityPolicy: VulnerabilityPolicy
}

interface Props {
  readonly organizationID: string
  readonly policyID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function VulnerabilityPolicyLoader({
  organizationID,
  policyID,
  children
}: Props) {
  return (
    <Query
      query={vulnerabilityPolicyQuery}
      variables={{ organizationID, policyID }}
      fetchPolicy="network-only"
    >
      {(result) => {
        const { data, error, loading } = result
        if (error || loading || !data) {
          return <div />
        }

        const vulnerabilityPolicy = normalizeVulnerabilityPolicy(
          data.vulnerabilityPolicy
        )

        return children({
          vulnerabilityPolicy
        })
      }}
    </Query>
  )
}

export const normalizeVulnerabilityPolicy = ({
  id,
  name,
  enabled,
  rules,
  allRules,
  applications,
  allApplications,
  serverEnvironments,
  allServerEnvironments,
  applicationImportance,
  ruleSeverities,
  remediationDays,
  valid,
  action,
  timeBasedEnabled,
  routeBasedEnabled,
  autoVerificationType
}) => ({
  id,
  name,
  enabled,
  rules,
  allRules,
  applications,
  allApplications,
  serverEnvironments,
  allServerEnvironments,
  applicationImportance,
  ruleSeverities,
  remediationDays,
  valid,
  action,
  timeBasedEnabled,
  routeBasedEnabled,
  autoVerificationType
})
